<template>
  <tr
    class="supplierrow"
    :class="{ selectedRow: item.isSelect }"
    @click="selectRow()"
    @focusout="calcProfit()"
  >
    <td style="text-align: center" class="GYONO cwS_1">
      <input type="text" readonly="true" v-model="item.c_supply_rownum" />
      <!-- <input type="text" readonly="true" v-model="item.c_supply_id" /> -->
    </td>
    <td style="text-align: center" class="CLAIMNO cwS_2">
      <!-- <input type="text" v-model="item.cnvClaimnumTmp" /> -->
      <select v-model="item.cnvClaimnumTmp">
        <option
          v-for="option in claims"
          v-bind:value="option.c_claim_number"
          v-bind:key="option.c_claim_number!"
        >
          {{ option.c_claim_number }}
        </option>
      </select>
    </td>
    <td class="SALESMONTH cwS_3">
      <!-- TODO:この日付の変更時のイベントでロック見てそうなコードあり -->

      <Mt_dtp4month
        v-model:contdate="item.cnvDateMonth"
        class="dtpJyutyuBulk jyutyuTable"
      ></Mt_dtp4month>
    </td>

    <td style="text-align: left" class="COURSE cwS_4">
      <select v-model="item.c_supply_item" @change="cngItem()">
        <option
          v-for="option in opItemtypeItem"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td style="text-align: left" class="COURSE cwS_5">
      <select v-model="item.c_supply_subject">
        <option
          v-for="option in getOpItemtypeSubjects()"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td style="text-align: center" class="BREAK_DOWN cwS_6">
      <select v-model="item.c_supply_breakdown">
        <option
          v-for="option in getOpItemtypeBreakdown()"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td class="SUPPLIER_CD cwS_7 selectBorderNone">
      <vSelect
        :options="opSuppliers"
        v-model="item.c_supplier_id"
        label="c_supplier_name"
        :reduce="(label:any) => label.c_supplier_id"
      ></vSelect>
    </td>
    <td style="text-align: left" class="SUM cwS_8">
      <input
        type="text"
        maxlength="10"
        v-model="item.cnvPrice"
        @focus="kanmaDel($event)"
        @blur="kanmaIns($event)"
      />
    </td>
    <td style="text-align: center" class="SYOHIZEI_RITU cwS_9 selectBorderNone">
      <!-- <vSelect
        :options="opTaxtate"
        v-model="item.c_supply_taxrate"
        :reduce="(label:any) => label.code"
      ></vSelect> -->

      <select v-model="item.c_supply_taxrate">
        <option
          v-for="option in opTaxtate"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td
      style="text-align: center; position: relative"
      class="PAYMENT_FLG cwS_9-2 tdDisables"
    >
      <!-- ※以下のinput要素は、deisable条件を持つが、条件に使用する要素が未実装の為、削除している -->
      <input
        type="checkbox"
        style="height: auto; width: auto"
        v-bind:checked="(item.c_supply_flag_chkclaim as any)"
        @change="item.c_supply_flag_chkclaim = cnvCb($event)"
      />
    </td>
    <td class="PAYMENT_YOTEI_DATE cwS_10">
      <!-- <input
        type="date"
        class="datepicker hasDatepicker"
        v-model="item.cnvDateExpPayment"
      /> -->
      <Mt_dtp
        v-model:contdate="item.cnvDateExpPayment"
        v-model:holidays="mastersData"
        class="dtpJyutyuBulk jyutyuTable"
      ></Mt_dtp>
    </td>
    <td style="text-align: center" class="PAYMENT_FLG cwS_11">
      <input
        type="checkbox"
        style="height: auto; width: auto"
        v-bind:checked="(item.c_supply_flag_paid as any)"
        :disabled="!authPayCheck.includes($store.state.id)"
        @change="item.c_supply_flag_paid = cnvCb($event)"
      />
      <!-- {{ $store.state.id }} -->
    </td>
    <td class="BIKO cwS_12">
      <input type="text" v-model="item.c_supply_remarks" />
    </td>
  </tr>
</template>
<script lang="ts">
import { EntitySupplyImple } from "furukawa-common/src/common/entity/EntitySupplyImple";
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  // CONST_OP_SUPPLY_TYPE,
  CONST_OP_TAXRATE,
  CONST_OP_ITEMTYPE_ITEM,
  CONST_OP_ITEMTYPE_SUBJECTS,
  CONST_OP_ITEMTYPE_BREAKDOWNS,
  CONST_ITEMTYPE_ITEM_KEIYAKU,
  CONST_ITEMTYPE_ITEM_KEIZOKU,
  CONST_ITEMTYPE_ITEM_KURIKOSI,
  CONST_ITEMTYPE_ITEM_MAEUKE,
  CONST_ITEMTYPE_ITEM_NESAGE,
  CONST_ITEMTYPE_ITEM_SHINKI,
  CONST_ITEMTYPE_ITEM_SYOUDAKU,
  CONST_ITEMTYPE_ITEM_TEKKYO,
  CONST_ITEMTYPE_SUBJECTS_BAITAI,
  CONST_ITEMTYPE_SUBJECTS_HIKAZEI,
  CONST_ITEMTYPE_SUBJECTS_KOUJI,
  CONST_AUTH_PAYCHECK,
} from "furukawa-common/src/common/constant/Constants";
//masters用
import { EntitySupplier } from "furukawa-common/src/common/entity/EntitySupplier";
import { item } from "@/dto/DtoItemsGetRes";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";

import Mt_dtp from "@/components/atoms/Mt_dtp.vue";
import Mt_dtp4month from "@/components/atoms/Mt_dtp4month.vue";
import { DtoMdDtp } from "furukawa-common/src/common/dto/DtoMdDtp";
import "@vuepic/vue-datepicker/dist/main.css";
import { EntityClaim } from "furukawa-common/src/common/entity/EntityClaim";

@Options({
  components: {
    vSelect,
    Mt_dtp,
    Mt_dtp4month,
  },
})
export default class Mo_tableJyutu_row_supply extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntitySupplyImple;

  // @Prop({ required: true })
  // items4Supplyers: EntitySupplier[];

  @Prop({ required: true })
  mastersData: DtoMastersGetRes;

  @Prop({ required: true })
  claims: EntityClaim[];

  authPayCheck = CONST_AUTH_PAYCHECK;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opItemtypeItem = CONST_OP_ITEMTYPE_ITEM.map((item) =>
    item.code === 8 ? { ...item, label: "前払" } : item
  );
  opItemtypeSubjects = CONST_OP_ITEMTYPE_SUBJECTS;
  opItemtypeBreakdown = CONST_OP_ITEMTYPE_BREAKDOWNS;
  opTaxtate = CONST_OP_TAXRATE;
  opSuppliers: EntitySupplier[] = [];

  //----------------------
  //セレクトボックス用メソッド
  //----------------------
  cngItem() {
    this.item.c_supply_subject = null;
    this.item.c_supply_breakdown = null;
  }
  getOpItemtypeSubjects(): {
    label: string;
    code: number;
  }[] {
    let indices: number[] = [];

    switch (this.item.c_supply_item) {
      case CONST_ITEMTYPE_ITEM_SHINKI:
        return CONST_OP_ITEMTYPE_SUBJECTS;
      case CONST_ITEMTYPE_ITEM_KEIZOKU:
        return CONST_OP_ITEMTYPE_SUBJECTS;
      case CONST_ITEMTYPE_ITEM_KEIYAKU:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_SYOUDAKU:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_NESAGE:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_KURIKOSI:
        indices.push(0); // 媒体
        indices.push(1); // 工事
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_TEKKYO:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_MAEUKE:
        indices.push(0); // 媒体
        indices.push(1); // 工事
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      default:
        return [{ label: "項目を選択してください", code: -1 }];
    }
  }
  getOpItemtypeBreakdown(): {
    label: string;
    code: number;
  }[] {
    let indices: number[] = [];
    switch (this.item.c_supply_subject) {
      case CONST_ITEMTYPE_SUBJECTS_BAITAI:
        indices.push(0); // 長期媒体
        indices.push(1); // 短期媒体
        indices.push(2); // 保守媒体
        indices.push(3); // 放映料
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      case CONST_ITEMTYPE_SUBJECTS_KOUJI:
        indices.push(4); // 施工費
        indices.push(5); // 撤去費
        indices.push(6); // 貼替料
        indices.push(7); // 電気代
        indices.push(8); // 保守管理費
        indices.push(9); // その他
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      case CONST_ITEMTYPE_SUBJECTS_HIKAZEI:
        indices.push(10); // 申請代
        indices.push(11); // 保険代
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      default:
        return [{ label: "科目を選択してください", code: -1 }];
    }
  }

  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //仕入先の選択肢作成
    this.opSuppliers = this.mastersData.getSupplier4NoneDelete([
      this.item.c_supplier_id!,
    ]);
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * クリック時の選択処理
   */
  async selectRow() {
    this.item.isSelect = true;
    this.$emit("selected", this.item.c_supply_id);
  }

  /**
   * 選択解除処理
   */
  async noneSelectRow() {
    this.item.isSelect = false;
  }

  //------------------

  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDel(obj: any) {
    // カンマを消す
    this.item.cnvPrice = obj.target.value.replace(/,/g, "");
    // if (this.item.cnvPrice == "0") this.item.cnvPrice = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaIns(obj: any) {
    let val: string = obj.target.value;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    this.item.cnvPrice = num;
  }

  /**
   * 金額再計算イベント発生
   */
  calcProfit() {
    //再計算イベント発生
    //-----------------------
    this.$emit("reCalc");
  }

  //------------------

  /**
   * チェックボックスの値を数値に変換する
   * @param event
   */
  cnvCb(event: any): number {
    if (event.target.checked) {
      return 1;
    } else {
      return 0;
    }
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
.selectedRow {
  background-color: black;
}
tr {
  border-bottom: 1px solid #ccc;
}

td {
  /* border: solid 1px #5e5e5e; */
  padding: 0;
  margin: 0;
  border-right: 1px solid #ccc;
}
tr > td:last-child {
  border-right: none;
}
td > input,
td > input,
td > select,
td > select {
  width: 100%;
  height: 28px;
  border: none;
}

/* .cwS_1 {
  min-width: 20px;
  max-width: 45px;
} */
.cwS_1 input {
  text-align: right;
}
/* .cwS_2 {
  min-width: 70px;
  max-width: 70px;
} */
.cwS_2 input {
  text-align: right;
}
/* .cwS_3 {
  min-width: 100px;
  max-width: 100px;
} */
.cwS_3 input {
  text-align: right;
}
/* .cwS_4 {
  min-width: 60px;
  max-width: 60px;
} */
/* .cwS_5 {
  min-width: 145px;
  max-width: 145px;
} */
.cwS_5-2 input {
  text-align: right;
}
/* .cwS_6 {
  min-width: 100px;
  max-width: 100px;
} */
.cwS_6 input {
  text-align: right;
}
/* .cwS_6-1 {
  min-width: 100px;
  max-width: 100px;
} */
.cwS_6-1 input {
  text-align: right;
}
/* .cwS_7 {
  min-width: 100px;
} */
/* .cwS_8 {
  min-width: 80px;
  max-width: 80px;
} */
/* .cwS_9 {
  min-width: 55px;
  max-width: 55px;
} */
.cwS_8 input {
  text-align: right;
}
.cwS_9 input {
  text-align: right;
}
/* .cwS_9-2 {
  min-width: 65px;
  max-width: 65px;
} */
/* .cwS_10 {
  min-width: 100px;
  max-width: 100px;
} */
.cwS_10 input {
  text-align: right;
}
/* .cwS_11 {
  min-width: 65px;
  max-width: 65px;
} */
/* .cwS_12 {
  min-width: 130px;
  width: auto;
} */

tr:hover td > input,
tr:hover td > select,
tr:hover td {
  background-color: #fafafa;
}
tr:hover {
  background-color: #dddddd;
  /* border-left: inherit; */
  /* -webkit-box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  z-index: 1; */
}

.selectedRow {
  -webkit-box-shadow: inset 0 0 0px 1px #886ab5 !important;
  box-shadow: inset 0 0 0px 1px #886ab5 !important;
  background: rgba(136, 106, 181, 0.1) !important;
  font-weight: 500;
  color: inherit;
  position: relative;
  border: 1px solid;
  /* border-bottom: none; */
}

.selectedRow td > input,
.selectedRow td > select,
.selectedRow td {
  background: rgba(136, 106, 181, 0.1) !important;
}
</style>
